import "./headerPage.css";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
interface HeaderPageProps {
  showImage?: boolean;
  title?: string;
  numberPartNumber?: string;
  nameNCM?: string;
  numberNCM?: string;
}

export const HeaderPage = ({
  title,
  numberPartNumber,
  nameNCM,
  numberNCM,
}: HeaderPageProps) => {
  const { sessionVerify } = useSelector(
    (state: RootState) => state.sessionInfo
  );

  return (
    <div className="containerHeaderPage">
      <div>
        {title && <span className="textHeaderPage">{title}</span>}
        <span
          style={{
            fontWeight: "700",
          }}
        >
          {sessionVerify?.pnNumberCode ||
            (numberPartNumber && (
              <span className="textHeader">
                {sessionVerify?.pnNumberCode !== null
                  ? sessionVerify?.pnNumberCode
                  : numberPartNumber}{" "}
              </span>
            ))}
        </span>
        {nameNCM && <span className="textHeaderPage"> - {nameNCM}</span>}
        {numberNCM && <span className="textHeader">{numberNCM}</span>}
      </div>
    </div>
  );
};

export default HeaderPage;
